import React from 'react';
import { TestimonialCard } from './ui/TestimonialCard';
import { CheckCircleIcon } from 'lucide-react';
export function SocialProof() {
  const testimonials = [{
    quote: 'MimiApp understands the pressure I face from my family about my career choices. The anxiety management tools helped me find peace without rejecting my cultural values.',
    author: 'David M.',
    location: 'Nairobi, Kenya',
    stars: 5
  }, {
    quote: 'I struggled with gambling addiction for years. The Growth Path journey combined with community support from others who understand the economic pressures we face has been life-changing.',
    author: 'Amina K.',
    location: 'Lagos, Nigeria',
    stars: 5
  }, {
    quote: "As a young professional, I couldn't afford traditional therapy. MimiApp's sliding scale pricing and 24/7 support made mental healthcare finally accessible to me.",
    author: 'Kwame O.',
    location: 'Accra, Ghana',
    stars: 4
  }];
  return <section id="testimonials" className="py-16 bg-gray-50" data-id="element-228">
      <div className="container mx-auto px-4" data-id="element-229">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-230">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-231">
            Stories of transformation
          </h2>
          <p className="text-lg text-gray-700" data-id="element-232">
            Hear from young Africans who found healing through culturally
            relevant support.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-233">
          {testimonials.map((testimonial, index) => <TestimonialCard key={index} quote={testimonial.quote} author={testimonial.author} location={testimonial.location} stars={testimonial.stars} data-id="element-234" />)}
        </div>
        <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-235">
          <div className="md:flex" data-id="element-236">
            <div className="md:w-1/2 p-8" data-id="element-237">
              <div className="flex items-center mb-6" data-id="element-238">
                <div className="bg-emerald-100 p-2 rounded-full mr-3" data-id="element-239">
                  <img src="https://f6s.com/static/images/f6s-logo.svg" alt="F6S Logo" className="h-6 w-6" data-id="element-240" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-241">
                  Recognized Excellence
                </h3>
              </div>
              <p className="text-gray-700 mb-6" data-id="element-242">
                MimiApp has been recognized as one of the "Top 14 Mental Health
                Startups in Kenya" by F6S, highlighting our innovation in
                culturally relevant mental healthcare.
              </p>
              <div className="space-y-3" data-id="element-243">
                <div className="flex items-center" data-id="element-244">
                  <CheckCircleIcon className="h-5 w-5 text-emerald-500 mr-2" data-id="element-245" />
                  <span className="text-gray-700" data-id="element-246">2,000+ active users</span>
                </div>
                <div className="flex items-center" data-id="element-247">
                  <CheckCircleIcon className="h-5 w-5 text-emerald-500 mr-2" data-id="element-248" />
                  <span className="text-gray-700" data-id="element-249">
                    15,000+ support sessions
                  </span>
                </div>
                <div className="flex items-center" data-id="element-250">
                  <CheckCircleIcon className="h-5 w-5 text-emerald-500 mr-2" data-id="element-251" />
                  <span className="text-gray-700" data-id="element-252">
                    50+ licensed African therapists
                  </span>
                </div>
                <div className="flex items-center" data-id="element-253">
                  <CheckCircleIcon className="h-5 w-5 text-emerald-500 mr-2" data-id="element-254" />
                  <span className="text-gray-700" data-id="element-255">
                    4.8/5 average user rating
                  </span>
                </div>
              </div>
            </div>
            <div className="md:w-1/2 bg-emerald-600 p-8 text-white flex flex-col justify-center" data-id="element-256">
              <h3 className="text-xl font-bold mb-6" data-id="element-257">
                What our therapist partners say:
              </h3>
              <blockquote className="mb-6" data-id="element-258">
                "MimiApp bridges the gap between evidence-based therapy
                techniques and African cultural contexts. As a therapist, I've
                seen how this approach resonates with young people who
                previously avoided seeking help."
              </blockquote>
              <div className="flex items-center" data-id="element-259">
                <img src="https://images.unsplash.com/photo-1573497019236-17f8177b81e8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80" alt="Dr. Nkosi" className="w-10 h-10 rounded-full mr-3 object-cover" data-id="element-260" />
                <div data-id="element-261">
                  <p className="font-medium" data-id="element-262">Dr. Nkosi Mbeki</p>
                  <p className="text-sm text-white/80" data-id="element-263">
                    Clinical Psychologist, South Africa
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}